import React, { useState, useEffect } from 'react';
import { Container } from "react-bootstrap";
import { useNavigate } from 'react-router-dom';
import Axios from '../../lib/axios/axiosInstance';
import { Flip, Slide, toast } from 'react-toastify';
import { userLogIn } from "../../services/auth";
import * as AuthVerify from '../../lib/common';

const PunchoutLogin = () => {
  const navigate = useNavigate();
  const [loginFailed, setLoginFailed] = useState(false)

  useEffect(() => {
    AuthVerify.removeSession();
    const queryParams = new URLSearchParams(window.location.search);
    const value = queryParams.get('potoken'); // Retrieve the value of a specific query parameter

    const login = async () => {
      const val = { token: value };
      const response = await userLogIn(val, 'accounts/tokenauthenticate');
      console.log(response)
      if (response && response.status == 200) {

        await AuthVerify.setSession(response.data);
        var refnum = await Axios.get(`/cart/activecarth?username=${response.data.email}&arnum=${response.data.arnum}`)

        if (refnum?.data && refnum.status == 200) {
          response.data.refnum = refnum.data.refnum;
          response.data.cartChanged = true;
        }

        if (response.data.applycorpsetting) {
          response.data.ccacNotNotified = true;
        }
        await AuthVerify.setSession(response.data);
        AuthVerify.setPermissions();
        toast.success('Log In Successful', {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
          transition: Slide,
        });
        navigate('/category?name=all')

      }
      else {
        toast.error('Authentication Failed', {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
          transition: Flip,
        })
        setLoginFailed(true);
      }
    }

    login().catch(console.error);
  }, [])

  return (
    <>
      <section className="main-container col1-layout">
        <Container className="main">
          <div className="col-main">
            <div className="shopping-cart-inner">
              <div className="col-main">
                <div className="my-account">
                  <div className="page-title">
                    <h2 style={{ paddingTop: "12px", textAlign: "center" }}>{loginFailed ? "Failed to Login" : "Please stay on this page while we are logging you in and preparing your catalog."}</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>

    </>
  );
};

export default PunchoutLogin;
